<template>
  <div class="fbn-input-container">
    <input
      v-model="input"
      placeholder="Facebook, LinkedIn URL or phone number, etc..."
      @keydown.enter="sleep(10).then(() => find())"
      @paste="queryFromClipboard"
      @focus="e => sleep(100).then(() => select(e))"
    />

    <button @click="find()">Find now</button>
    <QueryModal ref="dialog" />
  </div>
</template>

<script lang="ts" setup>
import { ref, useTemplateRef } from 'vue'
import { sleep } from '~/utils/helper'

const dialog = useTemplateRef('dialog')
const input = ref('')

const find = (text?: string) => dialog.value?.query(text || input.value)

const queryFromClipboard = (e: ClipboardEvent) => {
  const paste = e.clipboardData?.getData('text')

  paste && paste.trim() && setTimeout(find, 100)
}

const select = (event: FocusEvent) => {
  (event.target as HTMLInputElement)?.select()
}
</script>

<style scoped>
.fbn-input-container {
  background: white;
  border-radius: 9999px;
  padding: .5rem .8rem;
  padding-left: 1.5rem;
  display: flex;
  gap: 1rem;
  width: 100%;
}

.fbn-input-container > input {
  outline: none;
  flex: 1;
}

.fbn-input-container > button {
  background: #2f69ff;
  color: white;
  min-width: 99px;
  font-size: .875rem;
  position: relative;
  cursor: pointer;
  border-radius: 9999px;
  padding: .7rem 1rem;
  text-wrap: nowrap;
  width: max-content;
  flex: 0 1 auto;
  transition: all .24s;
}

.fbn-input-container > button:hover {
  background: black;
}
</style>
